module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-person-2ec8e76a.svg";